import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dataUtils from "../../../../../../common/utils/dataUtils";

type Props = {
  onActionEditar: (Id: number | null, openState: boolean, openAnalise: boolean) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
};

export const GenerateArquivoColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {

 const StatusBadge = ({ label, color }: { label: string, color: 'green' | 'yellow' | 'blue' }) => {
    const bgClass = color === 'green' ? 'bg-[#009688]' : color === 'yellow' ? 'bg-[#FFC107]' : 'bg-[#00BCD4]';
    return (
      <div className={`${bgClass} text-white px-2 py-1 rounded text-xs font-bold uppercase w-full text-center`}>
        {label}
      </div>
    );
  };

  return [
    {
      field: "Obsoleto",
      filterable: false,
      headerName: "Situação",
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
        const isObsoleto = params.value === 0 || params.value === false;
        
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <StatusBadge 
              label={isObsoleto ? "Obsoleto" : "Atual"} 
              color={isObsoleto ? 'yellow' : 'green'} 
              />
          </div>
        );
      }
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "DataVencimento",
      filterable: false,
      headerName: "Data Vencimento",
      flex: 1,
      maxWidth: 150,
      sortable: false,
      renderCell: (params) => {
            return (<div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
              {dataUtils.dataFormatada(params.value)}
            </div>);
          },
    },
    {
      field: "Nome",
      filterable: false,
      headerName: "Arquivo",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: 'IdContratoArquivo',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true, false)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}